import { BP, Colors, Typography, mq, mqHover } from '~/styles';
import type { TStyleSheet } from '~/types/emotion-styles';

const styles: TStyleSheet = {
  container: {
    [mq(BP.Medium)]: {
      maxWidth: 420,
      margin: '0 auto',
      paddingTop: 50,
    },
    [mq(BP.Large)]: {
      maxWidth: 600,
      paddingTop: '10px',
    },
  },
  title: {
    ...Typography.titleSection,
    color: Colors.audacyDarkNavy,
    marginBottom: 20,
    textAlign: 'left',
  },
  main: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  body: {
    ...Typography.bodySmall,
    color: Colors.grey80,
    marginRight: '40px',
    textAlign: 'left',
    [mq(BP.Large)]: {
      marginBottom: 20,
    },
  },
  toggle: {
    position: 'absolute',
    top: 0,
    right: 0,
    gap: 10,
    justifyContent: 'center',
    [mq(BP.Medium)]: {
      marginBottom: 50,
    },
    [mq(BP.Large)]: {
      marginBottom: 0,
    },
  },
  secondaryBtn: {
    background: 'transparent',
    border: '1px solid',
    borderColor: Colors.secondaryLightGrey,
    color: Colors.audacyDarkNavy,
    ...mqHover({
      background: 'transparent',
      borderColor: Colors.secondaryMediumGrey,
    }),
  },
};

export default styles;
